RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _, moment, CompareData) {

    'use strict';

    collections.CompanyData = Backbone.Collection.extend({
        model: RivalIQ.models.Company,

        triggerMethod: Marionette.triggerMethod,

        initialize: function (attributes) {

            const me = this;
            me.companyModel = new RivalIQ.models.CompanyLegacy();
            me.compareData = new CompareData();

            me.userCompanySets = [];
            me.companySetNameHash = {};
            me.landscapeId = null;

            me.stalestSocialData = null;
            me.earliestPostData = moment.utc();
            me.earliestPresenceData = moment.utc();


            _.extend(me, attributes);
        },

        comparator: function (a, b) {

            const focusCompanyId = RivalIQ.state.utils.getFocusedCompanyId();

            if (a.id === focusCompanyId) {

                return -1;
            } else if (b.id === focusCompanyId) {

                return 1;
            } else {

                const nameA = a.get('name').toLowerCase();
                const nameB = b.get('name').toLowerCase();
                return nameA.localeCompare(nameB);
            }
        },

        loadSingleCompanyChannel: function (options) {

            const me = this;

            me.loaded = false;

            // NOTE we should capture a reference to the time period used to
            // grab data here because otherwise there is no good way to tell,
            // sure each returned company record has its own mini time period,
            // but the format is not conducive for comparison to those codified
            me.timePeriod = _.get(options, 'timePeriod');

            return me.companyModel.getCompanyDataByCompanyId(options)
                .done(function (data) {

                    me.compareData = me.companyModel.compareData;
                    me.processResults((_.isArray(data) ? data : [data]));
                    me.triggerMethod('loaded');
                });
        },

        loadSingleCompany: function (id, timePeriod) {

            const me = this;
            return me.loadSingleCompanyChannel({
                companyId: id,
                timePeriod: timePeriod
            });
        },

        initializeCompareDataFromResults: function (results) {
            const me = this;
            _.each(results, _.bind(me.compareData.processTrendData, me.compareData));
        },

        fetch: function (attrs) {
            const me = this;

            _.defaults(attrs, {
                timePeriod: RivalIQ.state.view.get('timePeriod'),
                landscapeId: RivalIQ.state.view.get('landscapeId'),
                granularity: RivalIQ.enums.dataGranularity.trends
            });

            // Obsolete path
            if (!_.has(attrs, 'sources')) {
                // TODO log deprecation?
                return me.loadData(attrs.timePeriod);
            }

            const channels = _.compact(_.map(attrs.sources, function (source) {
                const Channel = collections.CompanyData.channels[source];
                return (Channel ? new Channel(me.compareData, attrs) : null);
            }));

            const failures = Array.prototype.concat.apply([], _.invokeMap(channels, 'validate'));

            if (failures.length) {
                const error = new Error('Invalid CompanyData parameters');
                error.failures = failures;
                throw error;
            }

            // NOTE we should capture a reference to the time period used to grab
            // data here because otherwise there is no good way to tell, sure each
            // returned company record has its own mini time period, but the format
            // is not conducive for comparison to those codified
            me.timePeriod = attrs.timePeriod;
            me.loaded = false;
            me.triggerMethod('loading');

            let deferred;

            function sourcesToSourceMask(sources) {
                const mask = _.reduce(sources, function (memo, source) {
                    return memo | RivalIQ.enums.sourceDetails[source].sourceMask;
                }, 0);

                return mask & attrs.activeSources;
            }

            // Clobber sources with source mask
            attrs = _.defaults({
                sources: sourcesToSourceMask(attrs.sources)
            }, attrs);
            if (_.has(attrs, 'companyId') && !_.isUndefined(attrs.companyId) && !_.isArray(attrs.companyId)) {
                deferred = me.companyModel.getCompanyDataByCompanyId(attrs);
            } else {
                deferred = me.companyModel.getLandscapeCompanyData(attrs);
            }

            return deferred.then(function (results) {
                const done = new $.Deferred();

                _.defer(function () {
                    _.extend(me.compareData, _.pick(attrs, 'timePeriod', 'landscapeId'));

                    me.preprocess(channels, results);
                    me.initializeCompareDataFromResults(results);

                    me.processResults(results);
                    me.triggerMethod('loaded');
                    done.resolve();
                });

                return done;
            });
        },

        preprocess: function (channels, results) {
            _.each(channels, function (channel) {
                const sourceDetails = RivalIQ.enums.sourceDetails[channel.id];
                const vals = _.compact(_.map(results, function (company) {
                    return company.periodSummary[sourceDetails.trendKey][0];
                }));

                channel.preprocess(vals);
            });
        },

        // TODO Should be refactored to do this processing on add / remove
        processResults: function (results) {
            const me = this;

            me.companySetNameHash = {};
            const userCompanySets = [];

            _.each(results, function (company) {

                if (!me.stalestSocialData || moment(company.periodSummary.dates.stalestSocialData) < moment(me.stalestSocialData)) {

                    me.stalestSocialData = company.periodSummary.dates.stalestSocialData;
                }

                _.each(RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.CROSS_CHANNEL].subSources, function (source) {

                    const trend = company.periodSummary[RivalIQ.enums.sourceDetails[source].trendKey];

                    const earliestPostDataDate = _.get(trend, [0, 'dates', 'earliestPostData'], me.earliestPostData);
                    me.earliestPostData = _.min([me.earliestPostData, moment.utc(earliestPostDataDate)]);

                    const earliestPresenceDataDate = _.get(trend, [0, 'dates', 'earliestPresenceData'], me.earliestPresenceData);
                    me.earliestPresenceData = _.min([me.earliestPresenceData, moment.utc(earliestPresenceDataDate)]);
                });

                _.each(company.companySetNames, function (companySetName) {

                    me.companySetNameHash[companySetName] = (me.companySetNameHash[companySetName] || []);
                    me.companySetNameHash[companySetName].push(company.id);
                    userCompanySets.push(companySetName);
                });

                let attrs = company;
                if (me.get(company.id)) {
                    attrs = _.omit(company, 'periodSummary');
                }

                me.add(attrs, {
                    merge: true
                });
            });

            me.userCompanySets = me._rebuildUserCompanySets(userCompanySets);
            me.metrics = CompareData.metrics;
        },

        reprocessCompanySets: function () {
            const me = this;

            const userCompanySets = [];
            me.companySetNameHash = {};

            me.each(function (company) {
                _.each(company.get('companySetNames'), function (companySetName) {
                    me.companySetNameHash[companySetName] = me.companySetNameHash[companySetName] || [];
                    me.companySetNameHash[companySetName].push(company.id);
                    userCompanySets.push(companySetName);
                });
            });
            me.userCompanySets = me._rebuildUserCompanySets(userCompanySets);
            me.metrics = CompareData.metrics;
        },

        _rebuildUserCompanySets: function (companySetNames) {
            return _(companySetNames)
                .uniq()
                .map(companySetName => {
                    const companySet = RivalIQ.state.companySets.get(companySetName)?.attributes;
                    if (companySet) {
                        return {
                            id: companySet.companySetId,
                            description: companySet.name
                        };
                    }
                })
                .compact()
                .value();
        },

        metricSorter: function (a, b) {
            if (a.value !== null && b.value !== null) {
                return (a.value > b.value) ? -1 : 1;
            } else if (a.value !== null && b.value === null) {
                return -1;
            } else if (a.value === null && b.value !== null) {
                return 1;
            }
        },

        getCompanyIdsByCompanySet: function (companySet) {
            const me = this;
            return _.map(me.getCompaniesByCompanySet(companySet), 'id');
        },

        getCompaniesByCompanySet: function (companySetDescriptor) {
            const me = this;
            return me.filter(function (company) {
                return company.hasCompanySet(companySetDescriptor);
            });
        },

        getCompaniesByCurrentTag: function () {
            const me = this;
            return me.getCompaniesByCompanySet(RivalIQ.state.view.get('companySetDescriptor'));
        },

        getCompanyCountByCompanySetName: function (companySetName, myCompanyId, shouldAddMe) {

            let retVal = this.length;
            let list = [];
            if (companySetName !== null) {
                list = this.getCompanyIdsByCompanySet(companySetName);
                if (list) {
                    retVal = list.length;
                    if (shouldAddMe && !_.some(list, function (item) {
                        return item === myCompanyId;
                    })) {
                        retVal += 1;
                    }
                }
            }
            return retVal;
        },

        // Get data for all metrics matching conditions for the provided source
        getMetricData: function (source, conditions) {
            const me = this;

            const details = RivalIQ.enums.sourceDetails[source];
            const sources = _.union([source], details.subSources);

            return _.reduce(sources, function (memo, source) {
                const cond = _.extend({
                    source: source
                }, conditions);
                const metrics = me.compareData.selectMetrics(cond);

                return memo.concat(metrics);
            }, []);
        },

        getMetricByTimeAnalysisMode: function (metric, mode) {

            const me = this;
            const compareData = me.compareData;
            switch (mode) {
                case RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD:
                    return compareData.getCurrData(metric);
                case RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD:
                    return compareData.getPrevData(metric);
                case RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE:
                    return compareData.getDeltaData(metric);
                case RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE:
                    return compareData.getDeltaRelData(metric);
                case RivalIQ.enums.timeAnalysisMode.DAILY_VALUES:
                case RivalIQ.enums.timeAnalysisMode.WEEKLY_VALUES:
                case RivalIQ.enums.timeAnalysisMode.MONTHLY_VALUES:
                    return compareData.getTimeSpanData(metric);
                default:
                    throw new Error(`unknown time analysis mode ${mode}`);
            }
        },

        getFilteredData: function (metric, timeAnalysisMode, companySetDescriptor, focusCompanyId) {

            const me = this;

            if (metric === null) {

                return null;
            }

            const compareData = me.compareData;
            const data = me.getMetricByTimeAnalysisMode(metric, Number(timeAnalysisMode));

            let companyListToShow;

            // default to active landscape (global) company set only when the companySetDescriptor
            // argument has been omitted completely
            if (_.isUndefined(companySetDescriptor)) {

                companySetDescriptor = RivalIQ.state.view.get('companySetDescriptor');
            }

            // determine the companies to show if a company set is specified
            if (companySetDescriptor) {

                companyListToShow = me.getCompanyIdsByCompanySet(companySetDescriptor);
            }

            // default to active landscape focus company
            focusCompanyId = (focusCompanyId || RivalIQ.state.utils.getFocusedCompanyId());

            const source = compareData.getMetricSource(metric);
            const sourceDetails = RivalIQ.enums.sourceDetails[source];
            const companyFilter = sourceDetails.companyFilter;

            const sourceFilteredCompanies = (_.isFunction(companyFilter) ? companyFilter(me) : []);

            const results = _.filter(data || [], function (datum) {

                const id = datum.companyId;
                const isFocusCompany = RivalIQ.state.utils.isFocusedCompany(id);
                const isTagged = (!companyListToShow || _.includes(companyListToShow, id));
                const isSourceFiltered = (sourceFilteredCompanies.length === 0 || _.includes(sourceFilteredCompanies, id));
                return (isSourceFiltered && (isFocusCompany || isTagged));
            });

            return results;
        },

        isUnderReview: function (options) {

            const me = this;
            options = options || {};

            return me.some(function (company) {

                const underReview = company.isUnderReview();
                return (_.result(options, 'recent') ? underReview && company.createdRecently() : underReview);
            });
        },

        /**
         * Gets a hydrated version of the associated time period.
         * @returns {object} A hydrated time period.
         **/
        getTimePeriod: function () {
            const me = this;
            const clone = _.clone(me.timePeriod);
            return RivalIQ.utils.timePeriod.rehydrate(clone);
        }
    });

    collections.CompanyData.channels = {};

}, window.moment, RivalIQ.data.CompareData);
